import ApiService from "../api.service";
const ENKTService = {
  GetENKTList(Code, Search, SortColumn, OrderType, PageNumber, PageLimit) {
    return ApiService.get(
      `/ENKT/GetENKTList?Code=${Code}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}`
    );
  },
  GetItemOfExpenseListForENKT(ENKTCode) {
    return ApiService.get(
      `/ENKT/GetItemOfExpenseListForENKT?ENKTCode=${ENKTCode}`
    );
  },
  GetENKTPropertiesList(ENKTCode) {
    return ApiService.get(`/ENKT/GetENKTPropertiesList?ENKTCode=${ENKTCode}`);
  },
  GetENKTPropertiesValuesList(ENKTCode, Number) {
    return ApiService.get(
      `/ENKT/GetENKTPropertiesValuesList?ENKTCode=${ENKTCode}&Number=${Number}`
    );
  },
};
export default ENKTService;
